import { Analytics } from "@vercel/analytics/react"

import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Perf } from 'r3f-perf'
import { StrictMode, Suspense } from 'react'

import Loader from './Components/Loader.jsx'
import App from './App.jsx'
import './index.css'

console.log("Hi if you notice a bug please contact me dishajain2358@gmail.com")


const isMobile = () => {
    return ( ( window.innerWidth <= 1000 ) && ( window.innerHeight <= 800 ) );
  }

const root = ReactDOM.createRoot(document.querySelector('#root'))

const fovForMobile = 100
const fovForPc = 45

root.render(
    <StrictMode>
        <Canvas
            camera={{
            fov: isMobile() ? fovForMobile : fovForPc,
            near: 0.1,
            far: 200,
            position: [52, 7, 12],
        }}
        >
            <Suspense fallback={<Loader/>}>
                <App/>   
            </Suspense>

            {/*<Perf position="top-left" />*/}
        </Canvas>

        <Analytics/>
        <div style={{ display: "none" }}>
  <section aria-hidden="true">
    <h1>Disha Jain - Computer Engineering Student</h1>
    <h2>Software Developer & Creative Technologist</h2>
    <h2>Based in Thane, Maharashtra, India</h2>
    <h2>Specialized in Programming and Creative Content</h2>
  </section>
  <section aria-hidden="true">
    <h2>Skills and Expertise</h2>
    <ul>
      <li>C, C++, Java, Python Developer</li>
      <li>Web Technologies (HTML, CSS)</li>
      <li>Database Management (DBMS)</li>
      <li>Video Editing & Content Creation</li>
      <li>Content Creation</li>
    </ul>
  </section>
  <section aria-hidden="true">
    <p>
      Welcome to the 3D portfolio of Disha Jain. This immersive portfolio showcases 
      my journey as a Computer Engineering undergraduate with expertise in software 
      development, creative technology, and problem solving. Explore my projects, 
      skills, and creative work in this modern luxury house experience.
    </p>
  </section>
  <noscript>
    <p>
      This 3D portfolio of Disha Jain showcases software development projects, 
      programming skills, and creative work. Please enable JavaScript to explore 
      the immersive experience.
    </p>
  </noscript>
</div>



    </StrictMode>

        
    
)